import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { sectionId } = useParams();
  const location = useLocation();
  const { pathname } = location;
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();

  if (!sectionId) return null;

  return (
    <>
      <Tabs
        tabItems={[
          {
            label: "Dues Rates",
            to: "/sections/:sectionId/billing/dues-rates" as Path,
            active: currentUrl === `/sections/${sectionId}/billing/dues-rates`
          }
        ].map(({ label, to, active }) => ({
          label,
          onClick: () => navigate(to, { params: { sectionId } }),
          active
        }))}
      />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
